import { render, staticRenderFns } from "./remark-dialog.vue?vue&type=template&id=0be7987a&scoped=true&"
import script from "./remark-dialog.vue?vue&type=script&lang=js&"
export * from "./remark-dialog.vue?vue&type=script&lang=js&"
import style0 from "./remark-dialog.vue?vue&type=style&index=0&id=0be7987a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be7987a",
  null
  
)

export default component.exports